


















































































































































































































































































































































































































































































import Modal from '../Base3.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';

import jQuery from 'jquery';
@Component({
	name: 'TermsConditionsMmic',
	components: {
		Modal,
	},
})
export default class ReadAcceptNoticesClaims extends Vue {
	@Prop() private acceptNotice: boolean;
	private closeTerms() {
		jQuery(`#notice`).modal('hide');
		this.acceptNotice = true;
	}
}
